export const colors = {
  primary: '#4A6FA5',
  teal: '#29BFC0',
  secondary: '#6B8CC7',
  background: '#F5F7FA',
  white: '#FFFFFF',
  text: '#333333',
  lightText: '#666666',
  border: '#E1E5EA',
  lightGray: '#D1D5DB',
  error: '#E53E3E',
  success: '#38A169',
  warning: '#F6AD55',
  shadow: '#000000',
};